import { Outlet } from "react-router-dom";
import RequireAnonymous from "./RequireAnonymous";

export default function AnonymousLayout() {
    return <RequireAnonymous>
        <Outlet />
    </RequireAnonymous>;
}
